import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row } from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import GetMerchantSettle from "../../functions/merchant/getMerchantSettle";
import moneyFormat from "../../functions/utils/moneyFormat";
import { EyeFilled, RedoOutlined } from "@ant-design/icons";
import SettleTransactions from "../../components/modal/settleTransactions";
import { useMerchant } from "../../context/merchantContext";
import SearchDatePickerIncome from "../../components/search/datePickerIncome";
import TablePagination from "components/pagination/tablePagination";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import { getMerchantId } from "service/storage";

const MerchantIncome = () => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFieldsIncome } = useMerchant();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [showTransactions, setShowTransactions] = useState(null);
  const [settleSettledAt, setSettleSettledAt] = useState(null);
  const [totals, setTotals] = useState({
    totalAmount: 0,
    totalMerchant: 0,
    xpayTotal: 0,
    totalSubMerchant: 0,
    totalProcessingAmount: 0,
  });
  useEffect(() => {
    prepareQueryStringAndSearch();
    // eslint-disable-next-line
  }, [searchFieldsIncome, page, pageSize]);

  const prepareQueryStringAndSearch = () => {
    const searchFieldsLength = Object.keys(searchFieldsIncome).length;
    let queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsIncome)
        .map((key) => {
          if (!searchFieldsIncome[key]) return "";
          if (key.includes("At")) {
            return `${key}=${searchFieldsIncome[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsIncome[key])}`;
        })
        .join("&");
      fetchInvoices(queryString, page, pageSize);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 20,
      className: "text-xs",
    },
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
      width: 20,
      render: (e) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Tоо/ш",
      dataIndex: "count",
      key: "count",
      width: 50,
      render: (e) => <span className="text-xs">{e}</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Дэд мерчант дүн",
      dataIndex: "subMerchantAmount",
      key: "subMerchantAmount",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Мерчант дүн",
      dataIndex: "merchantAmount",
      key: "merchantAmount",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "xPay авах дүн",
      dataIndex: "xpayAmount",
      key: "xpayAmount",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Процэсс дүн",
      dataIndex: "processingAmount",
      key: "processingAmount",
      width: 50,
      render: (e) => (
        <span className="text-xs text-orange-700">{moneyFormat(e)}₮</span>
      ),
      className: "text-xs",
      align: "right",
    },

    {
      title: (
        <SearchDatePickerIncome
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (e) => (
        <span className="text-xs">
          {e ? dayjs(e).format("YYYY-MM-DD") : "-"}
        </span>
      ),
      className: "text-xs",
      align: "center",
    },
    {
      title: "Төрөл",
      dataIndex: "settledType",
      key: "settledType",
      width: 50,
      render: (e) => <span className="text-xs">{e || "-"}</span>,
      className: "text-xs",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 50,
      render: (e) =>
        e === "SETTLED" ? (
          <Tag color="cyan" className="text-xs px-1 py-0.5">
            Өндөрлөсөн
          </Tag>
        ) : e === "ACTIVE" ? (
          <Tag color="blue" className="text-xs px-1 py-0.5">
            Идэвхтэй
          </Tag>
        ) : (
          <Tag color="default" className="text-xs px-1 py-0.5">
            Идэвхгүй
          </Tag>
        ),
      className: "text-xs",
    },
    {
      title: "Гүйлгээ",
      dataIndex: "transactions",
      key: "transactions",
      width: 50,
      render: (e) => {
        return (
          <div>
            <Tag color="green" className="text-xs px-1 py-0.5">
              {e?.filter((t) => t.status === "SETTLED").length || 0}
            </Tag>
            <Tag color="red" className="text-xs px-1 py-0.5">
              {e?.filter((t) => t.status !== "SETTLED").length || 0}
            </Tag>
          </div>
        );
      },
      align: "center",
      className: "text-xs",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 30,
      render: (e, r) => (
        <div className="flex flex-row gap-1">
          <Button
            size="small"
            onClick={() => showDetail(r)}
            icon={<EyeFilled style={{ color: "green", fontSize: 14 }} />}
            className="p-0 h-6 w-6 flex items-center justify-center"
          />
        </div>
      ),
      className: "text-xs",
    },
  ];

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  const showDetail = (row) => {
    setSettleSettledAt(row?.settledAt || null);
    setShowTransactions(row?.id || null);
  };

  const fetchInvoices = async (queryString, page, size) => {
    showLoading();
    const merchantId = getMerchantId();
    const response = await GetMerchantSettle(
      merchantId,
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      const totalFailed = response.data.reduce((acc, curr) => {
        const failedCount = curr.transactions.filter(
          (t) => t.status !== "SETTLED"
        ).length;
        return acc + failedCount;
      }, 0);
      const totalSuccess = response.data.reduce((acc, curr) => {
        const successCount = curr.transactions.filter(
          (t) => t.status === "SETTLED"
        ).length;
        return acc + successCount;
      }, 0);

      setPaginationData(response.pagination);
      setTotals({
        totalAmount: response.totalAmount || 0,
        totalMerchant: response.totalMerchant || 0,
        totalXpay: response.totalXpay || 0,
        totalSubMerchant: response.totalSubMerchantAmount || 0,
        totalProcessingAmount: response.totalProcessingAmount || 0,
        totalFailed: totalFailed,
        totalSuccess: totalSuccess,
      });
    }
  };

  const changePage = (page) => {
    setPage(page);
    fetchInvoices("", page, pageSize);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
    fetchInvoices("", current, size);
  };

  const refresh = () => {
    setPage(1);
    fetchInvoices("", 1, pageSize);
  };

  const closeShowTransactions = () => {
    setShowTransactions(null);
    setSettleSettledAt(null);
  };

  return (
    <div className="vatMerchantListontainer p-2 md:p-4">
      <Row className="mb-2 gap-2">
        <div>
          <Button
            type="primary"
            className={`${bg_button} rounded-xl ${bg_shadow}`}
            size="medium"
            onClick={refresh}
            icon={<RedoOutlined />}
          />
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 48vh)",
          }}
          pagination={false}
          dataSource={data}
          size="small"
          className="text-xs"
          summary={() => {
            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1} align="right">
                    <span className={`font-semibold ${bg_text}`}>
                      {moneyFormat(totals.totalAmount)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} />
                  <Table.Summary.Cell index={3} align="right">
                    <span className="font-semibold">
                      {moneyFormat(totals.totalSubMerchant)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} align="right">
                    <span className="font-semibold ">
                      {moneyFormat(totals.totalMerchant)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} align="right">
                    <span className="font-semibold ">
                      {moneyFormat(totals.totalXpay)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} align="right">
                    <span className="font-semibold text-orange-700">
                      {moneyFormat(totals.totalProcessingAmount)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} />
                  <Table.Summary.Cell index={8} />
                  <Table.Summary.Cell index={9} />
                  <Table.Summary.Cell index={10} />
                  <Table.Summary.Cell
                    className="flex flex-row gap-1"
                    index={11}
                    align="center"
                  >
                    <Tag color="green" className="font-semibold ">
                      {totals.totalSuccess}
                    </Tag>
                    <Tag color="red" className="font-semibold ">
                      {totals.totalFailed}
                    </Tag>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {showTransactions && (
        <SettleTransactions
          open={showTransactions}
          refresh={refresh}
          close={closeShowTransactions}
          settledAt={settleSettledAt}
        />
      )}
    </div>
  );
};

export default MerchantIncome;
